import { shouldForwardPropExclude } from '@synergy/utils';
import { styled } from '@mui/material';
import Card from '@mui/material/Card';

export interface SnackbarCardProps {
    cardColor?: string;
    textColor?: string;
    hasActions?: boolean;
}

export const SnackbarCard = styled(Card, {
    shouldForwardProp: shouldForwardPropExclude('color', 'cardColor', 'textColor', 'hasActions'),
})<SnackbarCardProps>(({ theme, textColor, cardColor, hasActions }) => ({
    backgroundColor: cardColor ?? theme.palette.primary.main,
    color: textColor ?? theme.palette.primary.contrastText,
    width: '100%',
    height: 48,
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 2),
    gap: theme.spacing(2),
    zIndex: 110000,
    boxShadow: '0px 2px 14px 0px #21272E42',

    ...(hasActions && {
        [theme.breakpoints.up('sm')]: {
            width: 500,
        },
    }),
}));
